import React from 'react';
import { Box, Flex, HStack, Text, IconButton } from '@chakra-ui/react';
import { Handle, Position } from 'reactflow';
import { FiClock, FiEdit, FiCopy, FiTrash2 } from 'react-icons/fi';

const DelayNode = ({ data }) => {
  return (
    <Box
      bg="white"
      borderWidth="2px"
      borderColor={data.selected ? 'purple.500' : '#a475f9'}
      borderRadius="xl"
      boxShadow={data.selected ? 'xl' : 'lg'}
      minW="240px"
    >
      <Handle type="target" position={Position.Left} style={{ background: 'black' }} />
      
      <Flex
        bg="#a475f9"
        color="white"
        px={4}
        py={2.5}
        borderTopRadius="xl"
        align="center"
        justify="space-between"
      >
        <HStack spacing={2}>
          <FiClock />
          <Text noOfLines={1} fontSize="sm" fontWeight="medium">Wait</Text>
        </HStack>
        <HStack spacing={1}>
          <IconButton
            size="xs"
            variant="ghost"
            color="white"
            icon={<FiEdit />}
            onClick={(e) => { e.stopPropagation(); data.onEdit?.(data.id); }}
          />
          <IconButton
            size="xs"
            variant="ghost"
            color="white"
            icon={<FiCopy />}
            onClick={(e) => { e.stopPropagation(); data.onDuplicate?.(data.id); }}
          />
          <IconButton
            size="xs"
            variant="ghost"
            color="white"
            icon={<FiTrash2 />}
            onClick={(e) => { e.stopPropagation(); data.onDelete?.(data.id); }}
          />
        </HStack>
      </Flex>

      <Box p={3.5}>
        <Text fontSize="sm" fontWeight="medium">
          {data.label || 'Wait'}
        </Text>
        {data.duration && (
          <Text fontSize="xs" color="gray.600" mt={1.5}>
            {data.duration} {data.unit || 'days'}
          </Text>
        )}
      </Box>

      <Handle type="source" position={Position.Right} style={{ background: 'black' }} />
    </Box>
  );
};

export default DelayNode;